import type { AppointmentResponse } from '@/types/scheduling-api';
import type { ArrivedGuardPatient } from '@/scheduling/lib/arrived-guard';
import { findPatientParticipant } from '@/shared/lib/appointment-participants';

/**
 * Pull the Mark-Arrived guard inputs (PROD-989) out of an
 * `AppointmentResponse`'s patient participant. The patient sub-shape isn't
 * fully typed on the participant, so we read the few fields the guard needs
 * via a narrow cast — mirroring Flutter's `appointment.patient.*` access.
 */
export function guardPatientFromAppointment(
  appt: AppointmentResponse | null | undefined,
): ArrivedGuardPatient | null {
  if (!appt) return null;
  const participant = findPatientParticipant(appt.participant);
  const patient = participant?.patient as
    | {
        identificationId?: string | null;
        dateOfBirth?: string | null;
        birthDate?: string | null;
        isMissingData?: boolean | null;
        guardianDetails?: {
          guaardianIdentificationId?: string | null;
          relationId?: string | null;
        } | null;
      }
    | undefined;
  if (!patient) return null;
  return {
    identificationId: patient.identificationId,
    guardianIdentificationId: patient.guardianDetails?.guaardianIdentificationId,
    guardianRelationId: patient.guardianDetails?.relationId,
    birthDateISO: patient.birthDate ?? patient.dateOfBirth,
    isMissingData: patient.isMissingData,
  };
}
